import moment from 'moment';
import {validNumber} from './validation';

const isNumber = value => {
    return /^[-]?\d+$/.test(value) ? Number(value) : 0;
};
export function isInputDate(value) {
    if (!value) {
        return false;
    } else {
        if (typeof value === 'string') {
            return isSpecialDate(value);
        } else if (typeof value === 'object') {
            return !moment(value).isValid();
        }
    }
    return true;
}
export function isSpecialDate(date) {
    return /\*|_|\?|\\|NULL/.test(date);
}
export function validFullYear(value: string) {
    const _value = Number(value.replace(/(\*|_|\?)/g, ''));
    if (value.length === 0) {
        return true;
    }
    if (value.length === 1) {
        return _value >= 1 && _value <= 2;
    }
    if (value.length === 2) {
        return _value >= 19 && _value <= 21;
    }
    if (value.length === 3) {
        return _value >= 190 && _value <= 210;
    }
    if (value.length === 4) {
        return _value >= 1900 && _value <= 2100;
    }
    return false;
}
export function dayOrMonthCheck(date, dateFormat) {
    const dataArray = date.split(' ');
    const dateFormatArray = dataArray[0].split('/');
    const calenderFormatArray = dateFormat.split(' ')[0].split('/');
    if (dateFormatArray[0].length > 0) {
        if (calenderFormatArray[0] === 'DD') {
            if (dateFormatArray[0].length === 1) {
                return validNumber(dateFormatArray[0], 3) && dateFormatArray[0] !== '00';
            } else if (dateFormatArray[0].length === 2) {
                return validNumber(dateFormatArray[0], 31) && dateFormatArray[0] !== '00';
            }
            return false;
        } else if (calenderFormatArray[0] === 'MM') {
            if (dateFormatArray[0].length === 1) {
                return validNumber(dateFormatArray[0], 1) && dateFormatArray[0] !== '00';
            } else if (dateFormatArray[0].length === 2) {
                return validNumber(dateFormatArray[0], 12) && dateFormatArray[0] !== '00';
            }
            return false;
        } else {
            return false;
        }
    } else {
        return true;
    }
}

export function dayAndMonthCheck(date: string, dateFormat: string, maxDay: number) {
    const dataArray = date.split(' ');
    const dateFormatArray = dataArray[0].split('/');
    const calenderFormatArray = dateFormat.split(' ')[0].split('/');

    if (dateFormatArray[1].length > 0) {
        if (calenderFormatArray[0] === 'DD') {
            return (
                validNumber(dateFormatArray[0], maxDay[isNumber(dateFormatArray[1])]) &&
                validNumber(dateFormatArray[0][0], 3) &&
                validNumber(dateFormatArray[1], 12) &&
                validNumber(dateFormatArray[1][0], 1) &&
                dateFormatArray[0] !== '00' &&
                dateFormatArray[1] !== '00'
            );
        } else if (calenderFormatArray[0] === 'MM') {
            return (
                validNumber(dateFormatArray[0], 12) &&
                validNumber(dateFormatArray[0][0], 1) &&
                validNumber(dateFormatArray[1], maxDay[isNumber(dateFormatArray[0])]) &&
                validNumber(dateFormatArray[1][0], 3) &&
                dateFormatArray[0] !== '00' &&
                dateFormatArray[1] !== '00'
            );
        } else {
            return false;
        }
    } else {
        return dayOrMonthCheck(date, dateFormat);
    }
}
export function dayAndMonthAndYearCheck(date, dateFormat, maxDay) {
    const dataArray = date.split(' ');
    const dateFormatArray = dataArray[0].split('/');
    const calenderFormatArray = dateFormat.split(' ')[0].split('/');
    if (dateFormatArray[2].length > 0) {
        if (calenderFormatArray[2] === 'YY') {
            if (calenderFormatArray[0] === 'DD') {
                return (
                    validNumber(dateFormatArray[0], maxDay[isNumber(dateFormatArray[1])]) &&
                    validNumber(dateFormatArray[1], 12) &&
                    validNumber(dateFormatArray[2], 99) &&
                    dateFormatArray[2].length <= 2 &&
                    dateFormatArray[0] !== '00' &&
                    dateFormatArray[1] !== '00'
                );
            } else if (calenderFormatArray[0] === 'MM') {
                return (
                    validNumber(dateFormatArray[0], 12) &&
                    validNumber(dateFormatArray[1], maxDay[isNumber(dateFormatArray[0])]) &&
                    validNumber(dateFormatArray[2], 99) &&
                    dateFormatArray[2].length <= 2 &&
                    dateFormatArray[0] !== '00' &&
                    dateFormatArray[1] !== '00'
                );
            } else {
                return false;
            }
        } else if (calenderFormatArray[2] === 'YYYY') {
            if (calenderFormatArray[0] === 'DD') {
                return (
                    validNumber(dateFormatArray[0], maxDay[isNumber(dateFormatArray[1])]) &&
                    validNumber(dateFormatArray[1], 12) &&
                    validFullYear(dateFormatArray[2]) &&
                    dateFormatArray[2].length <= 4 &&
                    dateFormatArray[0] !== '00' &&
                    dateFormatArray[1] !== '00'
                );
            } else if (calenderFormatArray[0] === 'MM') {
                return (
                    validNumber(dateFormatArray[0], 12) &&
                    validNumber(dateFormatArray[1], maxDay[isNumber(dateFormatArray[1])]) &&
                    validFullYear(dateFormatArray[2]) &&
                    dateFormatArray[2].length <= 4 &&
                    dateFormatArray[0] !== '00' &&
                    dateFormatArray[1] !== '00'
                );
            } else {
                return false;
            }
        } else {
            return false;
        }
    } else {
        return dayAndMonthCheck(date, dateFormat, maxDay);
    }
}
export function stringToMoment(data, dateFormat) {
    // eslint-disable-next-line
    if (!data || data == '0') {
        return null;
    }
    if (data._isValid) {
        return data;
    }
    return moment(data, dateFormat).isValid() ? moment(data, dateFormat) : null;
}
export function momentToString(newMoment, dateFormat) {
    if (newMoment) {
        if (moment.isMoment(newMoment)) {
            return newMoment.format(dateFormat);
        } else {
            return newMoment;
        }
    } else {
        return '';
    }
}

export function getRawDate(oldValue, value, dateFormat) {
    let newValue = value;

    if (newValue === 'N') {
        newValue = 'NULL';
    } else if (oldValue === 'NULL' && newValue === 'NUL') {
        newValue = '';
    } else if (value.length === 2 && oldValue.length === 1) newValue = `${value}/`;
    else if (value.length === 3 && oldValue.length === 4) newValue = value.substring(0, 1);
    else if (value.length === 5 && oldValue.length === 4) newValue = `${value}/`;
    else if (value.length === 6 && oldValue.length === 7) newValue = value.substring(0, 4);
    const isDateTimeFormat = dateFormat === 'DD/MM/YY HH:mm' || dateFormat === 'MM/DD/YY hh:mm a';
    if (isDateTimeFormat) {
        if (value.length === 8 && oldValue.length === 7) {
            newValue = `${value} `;
        } else if (value.length === 9 && oldValue.length === 10) {
            newValue = value.substring(0, 7);
        }
        if (value.length === 11 && oldValue.length === 10) {
            newValue = `${value}:`;
        } else if (value.length === 12 && oldValue.length === 13) {
            newValue = value.substring(0, 10);
        }
    }

    return newValue;
}

export function serverDateToRegularDate(serverDate: number, dateFormat: string) {
    if (!serverDate) {
        return '';
    }

    const rawDate = new Date(serverDate * 60000 + 567993600000);
    return rawDate && moment(rawDate).format(dateFormat);
}
